import { SIDEBAR_ACTIVE, SETTINGS_ACTIVE, PROFILE_ACTIVE, THEME, NOTIFICATION, MESSAGE } from "../types/styles";

export const toggleSidebar = (isOpen) => async (dispatch) => {
  dispatch({ type: SIDEBAR_ACTIVE, payload: isOpen });
};

export const toggleSettings = () => async (dispatch, getState) => {
  dispatch({
    type: SETTINGS_ACTIVE,
    payload: !getState().styles.settingsActive,
  });
};

export const toggleProfile = () => async (dispatch, getState) => {
  dispatch({
    type: PROFILE_ACTIVE,
    payload: !getState().styles.profileActive,
  });
};

export const setTheme = (isDarkTheme) => async (dispatch) => {
  dispatch({ type: THEME, payload: isDarkTheme });
};

export const setnotification = (data) => async (dispatch) => {
  dispatch({ type: NOTIFICATION, payload: data });
};

export const setmessage = (data) => async (dispatch) => {
  dispatch({ type: MESSAGE, payload: data });
};
